import React from "react";

import { IProductType } from "../../../../types/productType.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  type: IProductType;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewProductTypeForm: React.FC<Props> = (props) => {
  return (
    <div>
      {props.type.description && (
        <div className={styles.form}>
          <ViewInput title="Опис" value={props.type.description} isBig={true} />
        </div>
      )}
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewProductTypeForm;
